import styled from 'styled-components';
import { Typography } from 'antd';
import { colors } from 'styles/colors';

export const Subtitle = styled(Typography.Title)`
  &.ant-typography {
    font-size: 20px;
    font-weight: 600;
    color: ${colors.gray3};
    margin-bottom: 20px;
    width: 100%;
  }
`;
